import { render, staticRenderFns } from "./DocUploadModal.vue?vue&type=template&id=19fa351a&scoped=true"
import script from "./DocUploadModal.vue?vue&type=script&lang=js"
export * from "./DocUploadModal.vue?vue&type=script&lang=js"
import style0 from "./DocUploadModal.vue?vue&type=style&index=0&id=19fa351a&prod&lang=css"
import style1 from "./DocUploadModal.vue?vue&type=style&index=1&id=19fa351a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa351a",
  null
  
)

export default component.exports